import { toValue as t } from "vue";
function f(r) {
  if (r = t(r), r == null)
    return !1;
  if (Array.isArray(r))
    return !!r.length;
  if (r === !1)
    return !0;
  if (r instanceof Date)
    return !isNaN(r.getTime());
  if (typeof r == "object") {
    for (const i in r)
      return !0;
    return !1;
  }
  return !!String(r).trim().length;
}
export {
  f as i
};
//# sourceMappingURL=isDefined-DzVx0B6k.js.map
